module.exports = __webpack_public_path__ + "media/images/icon__twitter@2x-604d9ec7d6d0fc8cbced7b571007036e.png";